export default class SpecialRequestUpdateRequest {
  /**
   * Classe pour les réponses des demandes spéciales
   * @param {number} id L'identifiant de la demande
   * @param {string} answer La réponse à la demande
   * @param {ESpecialRequestStatus} status Le statut de la demande
   * @param {Number} requestId la requête associée
   * @param {AddressDto} address
   */
  constructor({
                id,
                answer = '',
                status,
                requestId,
                address
              }) {
    this.id = id;
    this.answer = answer;
    this.status = status;
    this.requestId = requestId;
    this.address = address;
  }
}
